import { createGraphqlHeader } from '../../utils/functions/headers';
import { graphQLEmptySplitApi } from '../emptySplitApi';
import { TValidateUserData } from '../../types/mvpMap';
import { getFilterDataForValidateUserQuery } from './queryHelpers';
import { User } from '../../utils/types';
import { updateAuthUser } from '../features/authUserSlice';
import { setSelectedCountry } from '../features/countrySlice';
import { setGAUserId } from '../../utils/analytics';

const getTransformedAuthUser = (
  data: TValidateUserData
) => {
  const userData = data?.data?.ValidateUser;
  const user: User = {
    userName: userData?.actorDetails?.actorName || 'dummy',
    role: userData?.actorDetails?.actorType || '',
    tncStatus: true,
    tncId: 0,
    userId: userData?.actorDetails?.actorId || 0,
    enterpriseIds: [],
    email: userData?.username || 'dummy',
    mobile: 0,
    ugdn: 0,
    user_name: userData?.username || 'dummy',
    countryName: userData?.countryName,
  };
  return user;
};

export const MVPGraphQlService =
  graphQLEmptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
      validateUser: builder.query<
        TValidateUserData,
        string
      >({
        query: (userName) => ({
          url: '',
          method: 'POST',
          data: {
            query:
              getFilterDataForValidateUserQuery(userName),
            variables: {},
          },
          headers: createGraphqlHeader(),
        }),
        async onQueryStarted(
          args,
          { dispatch, queryFulfilled }
        ) {
          queryFulfilled
            .then(
              ({ data }: { data: TValidateUserData }) => {
                if (
                  data?.data?.ValidateUser?.responseStatus
                    ?.status === 'SUCCESS'
                ) {
                  dispatch(
                    updateAuthUser(
                      getTransformedAuthUser(data)
                    )
                  );
                  // Set default country/wsId based on user's country
                  const userCountry =
                    data?.data?.ValidateUser?.countryName;
                  if (userCountry) {
                    dispatch(
                      setSelectedCountry(
                        userCountry.toLowerCase()
                      )
                    );
                  }
                  setGAUserId(
                    data.data.ValidateUser?.username
                  );
                }
              }
            )
            .catch((error) => error);
        },
      }),
    }),
  });

export const { useLazyValidateUserQuery } =
  MVPGraphQlService;
